import { createTheme } from '@one-thd/sui-atomic-components';

const LaborDaySecondaryOne = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

LaborDaySecondaryOne.palette['--sui-palette-background-primary'] = '128 131 102';
LaborDaySecondaryOne.palette['--sui-palette-button-background-primary'] = '255 255 255';
LaborDaySecondaryOne.palette['--sui-palette-text-primary'] = '255 255 255';
LaborDaySecondaryOne.palette['--sui-palette-text-subtle'] = '255 255 255';

export { LaborDaySecondaryOne };
